/**
 * Map checkout session lines + catalog products → A17 mixed-cart refund term inputs.
 * Missing / unknown fulfillmentClass fails closed to ORDINARY (no invented PREPARED).
 */

import type { CatalogProduct } from '../../shop/types.js';
import type {
  MixedCartFulfillmentClass,
  MixedCartLineTermInput,
} from './mixedCartRefundTermsPresenter.js';

function resolveFulfillmentClass(
  value: CatalogProduct['fulfillmentClass'] | undefined
): MixedCartFulfillmentClass {
  return value === 'PREPARED_TIME_SENSITIVE' ? 'PREPARED_TIME_SENSITIVE' : 'ORDINARY';
}

export function buildMixedCartRefundTermLines(
  sessionLines: readonly { readonly productId: number }[],
  catalog: readonly CatalogProduct[] | undefined
): MixedCartLineTermInput[] {
  if (sessionLines.length === 0) {
    return [];
  }
  const byId = new Map<number, CatalogProduct>();
  for (const product of catalog ?? []) {
    byId.set(product.id, product);
  }
  return sessionLines.map((line) => {
    const product = byId.get(line.productId);
    return {
      productId: line.productId,
      productName: product?.name?.trim() ? product.name : `#${line.productId}`,
      fulfillmentClass: resolveFulfillmentClass(product?.fulfillmentClass),
    };
  });
}
